import { now } from "./CDate";

export const parseDate = date => new Date(date)

export const nowISOString = () => (new Date()).toISOString();

export const nowDate = () => new Date();

export const dateRangeOverlap = ({ start: s1, end: e1 }, { start: s2, end: e2 }) => {
    return (!s1 || !e2 || new Date(s1) <= new Date(e2)) &&
           (!s2 || !e1 || new Date(s2) <= new Date(e1));
}

export const dateRangeOverlapExclusive = ({ start: s1, end: e1 }, { start: s2, end: e2 }) => {
    return (!s1 || !e2 || new Date(s1) < new Date(e2)) &&
           (!s2 || !e1 || new Date(s2) < new Date(e1));
}

export const dateRangeIncludes = ({ start: s1, end: e1 }, { start: s2, end: e2 }) => {
    return (!s1 || new Date(s1) <= new Date(s2)) &&
           (!e1 || new Date(e1) >= new Date(e2));
}

export const minDate = (list, field) => {
    let minEntry = null;
    let minValue = null;

    for (const entry of list) {
        const value = field !== undefined ? entry[field] : entry;
        const date = new Date(value);
        if (value && (!minValue || date < minValue)) {
            minValue = date;
            minEntry = value;
        }
    }

    return minEntry;
};

export const maxDate = (list, field) => {
    let maxEntry = null;
    let maxValue = null;

    for (const entry of list) {
        const value = field !== undefined ? entry[field] : entry;
        const date = new Date(value);
        if (value && (!maxValue || date > maxValue)) {
            maxValue = date;
            maxEntry = value;
        }
    }

    return maxEntry;
};

export const dateSameOrAfter = ({start: s1}, {start: s2}) => {
    return parseDate(s2) >= parseDate(s1);
}

export const dateInRangeInclusive = (date, { start, end }) => {
    const d = new Date(date);
    return (!start || d >= new Date(start)) && (!end || d <= new Date(end));
};

export const dateInRangeExclusive = (date, { start, end }) => {
    const d = new Date(date);
    return (!start || d >= new Date(start)) && (!end || d < new Date(end));
}

export const processQueryRange = (range, tz) => {
    const matchMath = /^\w*(today|now)(\w*([+-])\w*(\d+)([dhm]))?\w*$/;
    const toReturn = {};
    for (const field of ['start', 'end']) {
        if (!range?.[field] || typeof range[field] !== 'string') {
            continue;
        }
        const match = matchMath.exec(range[field]);
        if (match) {
            let dt = now(tz);
            if (match[1] == 'today') {
                dt = dt.startOf('day');
            }
            if (match[2]) {
                let delta = parseFloat(match[4]);
                if (match[3] === '-') {
                    delta = -delta;
                }
                switch (match[5]) {
                    case null:
                        break;
                    case 'd':
                        dt = dt.add(delta, 'days');
                        break;
                    case 'h':
                        dt = dt.add(delta, 'hours');
                        break;
                    case 'm':
                        dt = dt.add(delta, 'minutes');
                        break;
                    default:
                        throw new Error('Unknown delta unit on range math ' + match[3]);
                }
            }
            toReturn[field] = dt.toISOString();
        } else {
            toReturn[field] = parseDate(range[field]).toISOString();
        }
    }
    return toReturn;
}